export const setLanguage = (language) => {
    return async (dispatch) => {
        localStorage.setItem('language', language);
        await dispatch({ type: 'INIT_LANGUAGE', payload: language });
    };
};
